export const CONFIG = {
  "PROJECTNAME": "borek",
  "COMPANYNAME": "Borek",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10073001",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "rgb(150,118,60)",
    "primary100": "#F2CECC",
    "light": "rgb(150,118,60)",
    "secondary": "rgb(150,118,60)",
    "dark": "rgb(150,118,60)",
    "siteColor3": "#fff",
    "menuSecondary": "rgb(150,118,60)"
  }
};